import request from '@/utils/request'



// 获取角色list
export const role_list = (data) => {
    return request({
        url: '/erp/role/get-use-manager',
        method: 'post',
        data
    })
}

// 角色添加或者修改
export const role_set = (data) => {
    return request({
        url: '/erp/role/set-role-to-manager',
        method: 'post',
        data
    })
}

// 角色删除
export const role_del = (data) => {
    return request({
        url: '/erp/role/del-manager',
        method: 'post',
        data
    })
}

//获取所有权限
export const role_all_limit = (data) => {
    return request({
        url: '/erp/role/get-use-roles',
        method: 'post',
        data
    })
}